import React from 'react';
import { useTranslation } from 'react-i18next';
import './Illustrations.css';

/**
 * A quote being written, with a note showing what the last similar job took.
 * @returns {JSX.Element} Decorative drawing
 */
function QuoteIllustration() {
  const { t } = useTranslation();

  return (
    <svg className="illustration" viewBox="0 0 320 220" aria-hidden="true" focusable="false">
      <rect className="ill-paper" x="36" y="22" width="160" height="178" rx="14" />
      <text className="ill-text ill-text-heading ill-text-navy" x="56" y="56" fontSize="16">
        {t('illustrations.quote.title')}
      </text>
      <rect className="ill-line" x="56" y="72" width="104" height="8" rx="4" />
      <rect className="ill-line" x="56" y="90" width="84" height="8" rx="4" />
      <rect className="ill-line" x="56" y="108" width="96" height="8" rx="4" />
      <text className="ill-text ill-text-muted" x="56" y="152" fontSize="11">
        {t('illustrations.quote.estimate')}
      </text>
      <text className="ill-text ill-text-heading ill-text-navy" x="56" y="178" fontSize="20">
        {t('illustrations.quote.hours')}
      </text>

      <g transform="rotate(-5 232 104)">
        <rect className="ill-gold" x="160" y="58" width="146" height="92" rx="14" />
        <text className="ill-text ill-text-navy" x="176" y="90" fontSize="12">
          {t('illustrations.quote.noteTitle')}
        </text>
        <text className="ill-text ill-text-heading ill-text-navy" x="176" y="124" fontSize="22">
          {t('illustrations.quote.noteHours')}
        </text>
      </g>
    </svg>
  );
}

export default QuoteIllustration;
